import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';

import { TAccountClientContact, TAccountClientContactPayloadCreate, TAccountClientContactResponse, adaptAccountClientContactFromResponse, adaptAccountClientContactToRequest } from '../../types';
import { useAppSelector } from '../../hooks';
import { BACKEND_ACCOUNT_CLIENT } from '../../backend-paths';


export const accountClientContactCreateApi = createAsyncThunk(
	`POST/${BACKEND_ACCOUNT_CLIENT}/:client_id/contacts`,
	(payload: TAccountClientContactPayloadCreate, thunkApi) => {
		const { clientId, data } = payload;
		const path = `${BACKEND_ACCOUNT_CLIENT}/${clientId}/contacts`;

		const dataRequest = adaptAccountClientContactToRequest(data);

		return HttpService.post<TAccountClientContactResponse>(path, dataRequest).then(result => {
			return adaptAccountClientContactFromResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

type TInitialState = {
	item: TAccountClientContact | undefined,
	isLoading: boolean,
	error?: HttpError,
};

const initialState: TInitialState = {
	item: undefined,
	isLoading: false,
	error: undefined,
};

export const accountClientContactCreateSlice = createSlice({
	name: 'accountClientContactCreateSlice',
	initialState,
	reducers: {
		clearAccountClientContactCreate(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[accountClientContactCreateApi.pending.type]: (state) => {
			state.error = undefined;
			state.isLoading = true;
		},

		[accountClientContactCreateApi.fulfilled.type]: (state, action: PayloadAction<TAccountClientContact>) => {
			state.isLoading = false;
			state.item = action.payload;
		},

		[accountClientContactCreateApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.error = action.payload;
			state.isLoading = false;
		},
	},
});

export const useAccountClientContactCreateSelector = () => useAppSelector(state => state[accountClientContactCreateSlice.name]);

export const { clearAccountClientContactCreate } = accountClientContactCreateSlice.actions;
